import { CSSProperties, FC, PropsWithChildren } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import clsx from 'clsx';
import { Grip } from 'lucide-react';

import IconButton from '@mui/material/IconButton';

import css from './SortableCard.module.css';

interface SortableCardProps {
  id: string;
  className?: string;
}

export const SortableCard: FC<PropsWithChildren<SortableCardProps>> = ({ id, className, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 50 : 'auto',
    touchAction: 'none',
  };

  return (
    <div ref={setNodeRef} style={style} className={clsx(css.sortableCard, className)}>
      <IconButton className={css.sortableButton} {...attributes} {...listeners}>
        <Grip width={20} height={20} opacity={0.5} />
      </IconButton>

      <div className={css.sortableCardContent}>{children}</div>
    </div>
  );
};
